module.exports = __webpack_public_path__ + "static/media/orange-candy.87a15a77.png";